var Navigation = /** @class */ (function () {
    function Navigation() {
    }
    Navigation.navigateToUrl = function (url, history) {
        history.push(url);
    };
    Navigation.pop = function (history) {
        history.goBack();
    };
    return Navigation;
}());
export default Navigation;
//# sourceMappingURL=navigationUtils.js.map